export enum EstruturaTipo {
  ESTAVEL = 'ESTAVEL',
  NAO_ESTAVEL = 'NAO_ESTAVEL',
}
